<template>
    <div class="model-show">
        <div class="item-list-inner">
            <template v-if='searchMode'>
                <div class="search-container">
                    <div class="item-list-search">
                        <input type="text" v-model="searchText" :placeholder="$tc('itemList.search')">
                        <span class="icon-icon_search-2"></span>
                    </div>
                </div>
            </template>
            <div class="model-show-list"  @scroll="handleScroll">
                <div class="model-show-list-content">
                    <template v-if='searchText.length===0'>
                        <ul
                            class="devices unclassic-first"
                            :class="{ 'has-following-category': deviceList.length !== 0 }"
                            v-if='noCateDevices.length!==0'>
                            <li
                                v-for="(item, index) in noCateDevices"
                                :key="index"
                                class="customer-item">
                                <img :src="item.image || placeholderImg" >
                                <span>
                                    <a :href="item.link" target="_blank">{{ item.text }}</a>
                                </span>
                            </li>
                        </ul>
                        <ul>
                            <li
                                v-for="series in deviceList"
                                :key='series.id'
                                class="cate">
                                <p class="cate-name">{{series.i18n.name}}</p>
                                <ul
                                    class="devices unclassic-second"
                                    :class="{ 'has-following-series': series.series && series.series.length !== 0 }"
                                    v-if='series.modelShow.length!==0'>
                                    <li
                                        v-for="(item, index) in series.modelShow"
                                        :key="index"
                                        class="customer-item">
                                        <img :src="item.image || placeholderImg" >
                                        <span>
                                            <a :href="item.link" target="_blank">{{ item.text }}</a>
                                        </span>
                                    </li>
                                </ul>
                                <div
                                    v-for="item in series.series"
                                    :key="item.id"
                                    class="series">
                                    <p class="series-name" :class="{ 'has-note': item.i18n.note }">{{item.i18n.name}}</p>
                                    <p class="series-note" v-if="item.i18n.note" v-html="item.i18n.note"></p>
                                    <ul class="devices">
                                        <li
                                            v-for="(model, index) in item.modelShow"
                                            :key="index"
                                            class="customer-item">
                                            <img :src="model.image || placeholderImg" >
                                            <span>
                                                <a :href="model.link" target="_blank">{{ model.text }}</a>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                        <ul class="devices">
                            <li
                                v-for="(item, index) in customerList"
                                :key="index"
                                class="customer-item"
                                :title="item.text">
                                <img :src="item.image || placeholderImg" >
                                <span>
                                    <a :href="item.link" target="_blank">{{ item.text }}</a>
                                </span>
                            </li>
                        </ul>
                    </template>
                </div>
                <div class="empty-state" v-show="customerList.length===0">
                    <img :src="emptySearchImg" class="empty-state-img">
                    <span class="empty-state-text" v-html="searchText.length !== 0 ? noMatch : $t('dashboard.noData')"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import PlaceholderImg from '@/common/images/common/device_placeholder.svg';
import EmptySearchImg from '@/common/images/common/empty_search.png';

export default Vue.extend({

    props: {

        list: {
            type: Array,
            default: (): any[] => []
        },
        note: String,
        category: {
            type: Array,
            default: (): any[] => []
        },
        searchMode: {
            type: Boolean,
            default: true
        },
        noMatch: {
            type: String
        }
    },

    data () {

        return {

            searchText: '',
            showTopMore: false,
            showButtomMore: false,
            deviceList: [] as any[],
            noCateDevices: [] as any[],
            cateNew: JSON.parse( JSON.stringify( this.category )),
            placeholderImg: PlaceholderImg,
            emptySearchImg: EmptySearchImg,

        };

    },

    created () {

        let deviceList: any[] = [];

        for ( let [index, item] of this.list.entries()) {

            for ( let cate of this.cateNew ) {

                if ( cate.models.includes( item.key )) {

                    cate.sort = typeof cate.sort !== 'undefined' ? cate.sort : index;

                }

            }

        }

        let modelShow: any[] = [];
        let modelShowTotal: any[] = [];
        for ( let cate of this.cateNew ) {

            modelShow = [];
            // 一级分类
            if ( cate.parentKey === '' ) {

                for ( let device of this.list ) {

                    if ( cate.models.includes( device.key ) && device.visible === 'enabled' ) {

                        modelShow.push( device );
                        modelShowTotal.push( device );

                    }

                }
                cate.modelShow = modelShow;
                deviceList.push( JSON.parse( JSON.stringify( cate )));

            } else { // n级分类

                for ( let item of deviceList ) {

                    if ( item.key === cate.parentKey ) {

                        item.series = typeof item.series === 'undefined' ? [] : item.series;
                        for ( let device of this.list ) {

                            if ( cate.models.includes( device.key ) && device.visible === 'enabled' ) {

                                modelShow.push( device );
                                modelShowTotal.push( device );

                            }

                        }
                        cate.modelShow = modelShow;
                        item.series.push( JSON.parse( JSON.stringify( cate )));

                    }

                }

            }

        }

        // 查找不在分类里的机型
        modelShowTotal = modelShowTotal.map( item => item.key );

        for ( let item of this.list ) {

            if ( !modelShowTotal.includes( item.key ) && item.visible === 'enabled' ) {

                this.noCateDevices.push( item );

            }

        }

        for ( let item of deviceList ) {

            let total = this.recursionAdd( item );
            item.total = total.concat( item.modelShow );
            item.series = item.series?.filter( series => series.total.length !== 0 );

        }

        // 过滤掉一级分类中没有机型的分类
        let newList: any[] = [];
        for ( let item of deviceList ) {

            if ( item.total.length !== 0 ) {

                newList.push( item );

            }

        }

        // 递归查找每个分类的排序，获取当前分类下最小排序
        for ( let item of newList ) {

            let minSort = this.recursionScan( item );
            item.sort = item.sort < minSort ? item.sort : minSort;

        }

        this.recursionSort( newList );
        this.deviceList = newList;

    },
    computed: {

        customerList (): any[] {

            return this.list.filter(

                item => {

                    return item.text.toLowerCase().includes( this.searchText.toLowerCase());

                }
            );

        }

    },
    methods: {
        handleScroll ( e ) {

            const { scrollTop, clientHeight, scrollHeight } = e.target;
            this.showTopMore = scrollTop > 0;
            this.showButtomMore = scrollTop + clientHeight < scrollHeight;

        },
        recursionScan ( cate ) {

            if ( typeof cate === 'undefined' ) {

                return 999999;

            }
            let minSort = typeof cate.sort === 'undefined' ? 99999 : cate.sort;
            if ( typeof cate.series !== 'undefined' ) {

                for ( let subCate of cate.series ) {

                    let insideSort = this.recursionScan( subCate );
                    minSort = insideSort < minSort ? insideSort : minSort;

                }

            }

            cate.sort = minSort;
            return minSort;

        },
        recursionSort ( array ) {

            if ( typeof array === 'undefined' ) {

                return;

            }
            array = array.sort(( a, b ) => a.sort - b.sort );
            for ( let subArray of array ) {

                this.recursionSort( subArray.series );

            }

        },
        recursionAdd ( array ): any[] {

            if ( typeof array === 'undefined' ) {

                return [];

            }
            let device: any[] = [];
            device = device.concat( array.modelShow );
            if ( array.series !== undefined ) {

                for ( let subArray of array.series ) {

                    device = device.concat( this.recursionAdd( subArray ));

                }

            }
            array.total = device;

            return device;

        }
    }

});
</script>
<style lang="less" scoped>
    .model-show{
        width: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding-top: 24px;
        @media @mobile{
            padding-top: 16px;
        }
    }
    div.model-show-list{
        overflow-y: auto;
        overflow-y: overlay;
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        @media @pc{
            padding: 32px 0 32px;
        }
        @media @mobile{
            padding: 0;
        }
        &::-webkit-scrollbar{
            width: 8px;
            right: 20px;
        }
        &::-webkit-scrollbar-thumb{
            background-color: @font_tertiary;
            border-radius: 8px;
        }
        .top-shadow{
            height: 20px;
            position: absolute;
            width: 100%;
            background: linear-gradient(0deg, rgba(255,255,255,0) 0%, @white 100%);
            z-index: 10;
            @media @pc{
                margin-left: 0;
                margin-top: -32px;
            }
            @media @mobile{
                margin-left: 0;
                margin-top: 0;
            }
        }
        .bottom-shadow{
            height: 20px;
            position: absolute;
            width: 100%;
            background: linear-gradient(180deg, rgba(255,255,255,0) 0%, @white 100%);
            z-index: 10;
            @media @pc{
                margin-left: 0;
                bottom: 32px;
            }
            @media @mobile{
                margin-left: 0;
                bottom: 0;
            }
        }
    }
    .search-container{
        border-bottom: 1px solid @line;
        padding-top: 4px;
        @media @pc{
            margin-bottom: 0;
        }
    }
    .item-list-search{
        position: relative;
        background-color: @white;
        @media @pc{
            width: 350px;
            margin-bottom: 24px;
        }
        @media @mobile{
            width: 100%;
            margin-bottom: 24px;
        }
        input{
            box-shadow: inset 0 0 0 1px @font_tertiary;
            outline: none;
            border: 2px solid transparent;
            box-sizing: border-box;
            border-radius: 4px;
            color: @font_secondary;
            &:focus{
                border-color: @b_5;
                box-shadow: 0 0 0 4px rgba(5, 145, 255, 0.1);
                caret-color: @b_5;
            }
            @media @pc{
                width: 100%;
                height: 46px;
                padding: 0 40px 0 12px;
                font-size: 16px;
            }
            @media @mobile{
                width: 100%;
                height: 40px;
                padding: 0 36px 0 12px;
                font-size: 14px;
            }
        }
        span{
            color: #999;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            @media @pc{
                right: 14px;
                font-size: 22px;
            }
            @media @mobile{
                right: 12px;
                font-size: 18px;
            }
        }
    }
    .item-list-inner{
        flex: 1;
        min-height: 0;
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        overflow-x: hidden;
        p.cate-name{
            font-weight: 600;
            line-height: 1.3;
            color: @font_primary;
            text-align: left;
            @media @pc{
                font-size: 22px;
                margin-bottom: 16px;
            }
            @media @mobile{
                font-size: 18px;
                margin-bottom: 16px;
            }
        }
        p.series-name{
            font-weight: 600;
            line-height: 1.4;
            color: @font_primary;
            text-align: left;
            @media @pc{
                font-size: 16px;
                padding: 8px 0;
                margin-bottom: 20px;
            }
            @media @mobile{
                font-size: 14px;
                padding: 6px 0;
                margin-bottom: 16px;
            }
            &.has-note{
                margin-bottom: 0;
            }
        }
        p.series-note{
            color: @font_secondary;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.4;
            text-align: left;
            /deep/ a{
                color: @font_secondary;
                text-decoration: underline;
            }
            @media @pc{
                margin-bottom: 20px;
            }
            @media @mobile{
                font-size: 12px;
                margin-bottom: 16px;
            }
        }
        ul.devices{
            display: flex;
            flex-wrap: wrap;
            @media @pc{
                max-width: 904px;
                row-gap: 20px;
            }
            @media @mobile{
                row-gap: 20px;
            }
            &.unclassic-first{
                &.has-following-category{
                    @media @pc{
                        margin-bottom: 64px;
                    }
                    @media @mobile{
                        margin-bottom: 48px;
                    }
                }
            }
            &.unclassic-second{
                &.has-following-series{
                    @media @pc{
                        margin-bottom: 48px;
                    }
                    @media @mobile{
                        margin-bottom: 32px;
                    }
                }
            }
        }

        li{
            list-style: none;
            &.cate{
                margin-bottom: 64px;
                @media @mobile{
                    margin-bottom: 48px;
                }
                &:last-of-type{
                    margin-bottom: 0;
                }
            }
            &.customer-item{
                display: flex;
                align-items: center;
                overflow: hidden;
                @media @pc{
                    width: 20%;
                }
                @media @mobile{
                    width: 50%;
                }
            }
            img{
                width: 50px;
                height: 50px;
                flex-shrink: 0;
                border-radius: 4px;
            }
            span{
                text-align: left;
                word-break: break-word;
                font-size: 14px;
                line-height: 1.4;
                color: @font_primary;
                padding: 8px 16px 8px 8px;
                a{
                    color: @font_primary;
                }
            }
            div.series{
                @media @pc{
                    margin-bottom: 48px;
                }
                @media @mobile{
                    margin-bottom: 32px;
                }
                &:last-child{
                    margin-bottom: 0;
                }
            }
        }
    }
    .empty-state{
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 20px;
        .empty-state-img{
            @media @pc{
                width: 120px;
                height: 120px;
            }
            @media @mobile{
                width: 72px;
                height: 72px;
            }
        }
        .empty-state-text{
            color: @font_secondary;
            font-size: 16px;
            line-height: 1.4;
            text-align: center;
            /deep/ a {
                color: @brand_light;
                text-decoration: none;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
</style>
